import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
      <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer inline-flex items-center gap-1">
        <i className="ri-home-4-line"></i>
        首页
      </Link>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="inline-flex items-center gap-1">
          <i className="ri-arrow-right-s-line text-foreground-300"></i>
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-600 transition-colors cursor-pointer">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}